import * as yup from 'yup';

export const formSchema = yup.object({
    price: yup.mixed().required(),
    bonus_hours: yup.mixed().optional().nullable(),
    bonus_amount: yup.mixed().optional().nullable(),
    contract_type: yup.string(),
    manager_price_per_hour: yup.mixed().optional().nullable(),
});
